import { render, staticRenderFns } from "./SingleMessage.vue?vue&type=template&id=439bbcb6"
import script from "./SingleMessage.vue?vue&type=script&lang=js"
export * from "./SingleMessage.vue?vue&type=script&lang=js"
import style0 from "./SingleMessage.vue?vue&type=style&index=0&id=439bbcb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports